import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { CourseVersions } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/courses/$courseId/versions")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <CourseVersions />
    </RouteGuard>
  ),
});
